import { Category } from "./category.model";
import { Plan } from "./plan.model";

export class Assembly {
    Name: string = '';
    Description: string = '';
    Type: string = 'O';
    AID: number = 0;
    CategoryID: number = 321;
    FID: number = 5;
    Categories: Category = new Category();
    AssemblyPriceTable: AssemblyPriceTable[] = [];
    AssemblyPrice: number | undefined;
    isDummy: boolean | undefined;
    hidden?: boolean;
    constructor(assembly?: Partial<Assembly>) {
        if(assembly) {
            Object.assign(this, assembly);
        }
    }
}

export interface AssemblySaveRequest {
    assembly: Partial<Assembly>;
    assemblyPriceTable: Partial<AssemblyPriceTable>[];
  }

export class AssemblyPriceTable {
    PlanID: number = 0;
    Price: number = 0;
    AID: number = 0;
    APID: number = 0;
    Type: boolean = false;
    FID: number = 0;
    DateUpdated?: Date
    Plans?: Plan

    constructor(data: Partial<AssemblyPriceTable>) {
        Object.assign(this, data);
    }
}
